import { Carousel } from '../core'

$.fn.Rooms = function() {
  let self = this
  self.roomCarousel = undefined
  
  return function() {
    self.roomCarousel = new Carousel(self.get(0), {
      slidesPerView: 1,
      speed: 500,
      loop: true,
      autoHeight: true,
      spaceBetween: 32,
      initialSlide: 2,
      freeMode: true,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1.5,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        prevEl: self.find('.carousel__toolbar .swiper-button-prev').get(0),
        nextEl: self.find('.carousel__toolbar .swiper-button-next').get(0),
      },
    })
    self.roomCarousel.init()
    return self
  }()
}

$('.rooms-list__carousel').each(function() {
  $(this).Rooms()
})